import { FC } from 'react'

import {
  FreeformTextareaEditor,
  FreeformTextareaProps
} from '../FreeformTextareaEditor/FreeformTextareaEditor'

export const SQLAdvancedEditor: FC<FreeformTextareaProps> = ({ ...props }) => (
  <FreeformTextareaEditor {...props} language="sql" />
)
